export async function asyncForEach<T>(array: T[], callback: (item: T, index: number, allItems: T[]) => void): Promise<void> {
  const next = async (index: number) => {
    await callback(array[index], index, array);
    if (index < array.length - 1) {
      await next(index + 1);
    }
  };
  await next(0);
}

export default asyncForEach;
